/* src/pages/no-access/page-no-access.component.scss */
:host {
  display: block;
}
.message {
  margin-left: 20px;
}
/*# sourceMappingURL=page-no-access.component-FGHHAEEZ.css.map */
